<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <div fxLayout="row wrap" fxLayout.lt-sm="column" class="dialog-container">
      <div fxFlex="100" class="pr-1" *ngIf="this.saveParcelas">
        <mat-progress-bar mode="indeterminate" class="full-width"></mat-progress-bar>
      </div>
      <div fxFlex="100" class="pr-1 table-container" *ngIf="!this.saveParcelas">
        <form [formGroup]="doctoCForm" (keydown.enter)="$event.preventDefault()">
          <div formArrayName="financRps">
            <ngx-datatable
              class="material ml-0 mr-0 custom-datatable"
              #ngxDatatable
              [rows]="parcelasFormArray.controls"
              [headerHeight]="50"
              [footerHeight]="0" 
              [scrollbarH]="true"
              [scrollbarV]="true"
              [messages]="{emptyMessage:'Nenhum Item encontrado'}"
              [limit]="pageSizeItem"
              [rowHeight]="60"
              [style.height.px]="500"
              [columnMode]="'standard'"
            >
              <ngx-datatable-column name="#" [minWidth]="25" [maxWidth]="40">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                  <strong>{{ rowIndex+1 }}</strong>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Opções" [minWidth]="80" [maxWidth]="100">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                  <div class="cell-top-align">
                    <ng-container *ngIf="!lcto.contemBaixa">
                      <button mat-icon-button mat-sm-button *ngIf="!this.isEditableParcela[rowIndex]" class="green-button"
                      (click)="this.isEditableParcela[rowIndex]=!this.isEditableParcela[rowIndex];">
                      <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button mat-sm-button color="success" *ngIf="this.isEditableParcela[rowIndex]" (click)="saveParcela(rowIndex, row)">
                      <mat-icon>save</mat-icon>
                      </button>
                    </ng-container>
                    <button mat-icon-button mat-sm-button color="primary" matTooltip="Editar/Detalhes da parcela" (click)="$event.preventDefault();editParcela(row.value)">
                      <mat-icon>launch</mat-icon>
                    </button>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Docto" [minWidth]="100" [maxWidth]="130">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.value?.docto }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Parc" [minWidth]="40" [maxWidth]="60">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <div style="text-align:right">
                    {{ row?.value?.parcela }}
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Emissão" [minWidth]="100" [maxWidth]="120">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <div style="text-align:right">
                    {{ row?.value?.emissao | date:'dd/MM/yyyy'}}
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Dias" [minWidth]="60" [maxWidth]="80">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditableParcela[rowIndex]">
                    {{ row?.value?.dias }}
                  </ng-container>
                  <ng-container *ngIf="isEditableParcela[rowIndex]">
                    <mat-form-field class="full-width">
                      <input matInput id="dias" type="text" name="dias" step="1" (focus)="$event.target.select()"
                        [formGroupName]="rowIndex" [formControl]="row.controls['dias']" (blur)="changeDias(row)">
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Vcto" [minWidth]="160" [maxWidth]="180">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditableParcela[rowIndex]">
                    {{ row?.value?.vcto | date:'dd/MM/yyyy, EEE'}}
                  </ng-container>
                  <ng-container *ngIf="isEditableParcela[rowIndex]">
                    <mat-form-field class="full-width">
                      <input matInput name="vcto" type="date" (focus)="$event.target.select()"
                        [formGroupName]="rowIndex" [formControl]="row.controls['vcto']" (blur)="changeVcto(row)">
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
              
              <ngx-datatable-column name="Valor" [minWidth]="120" [maxWidth]="150">
                <ng-template ngx-datatable-header-template let-column="column">
                  <div style="text-align:right">
                    <span title="Valor Nominal do Título">Valor</span>
                  </div>
                </ng-template>
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <div style="text-align:right">
                    <ng-container *ngIf="!isEditableParcela[rowIndex]">
                      {{ row?.value?.valorTotal | number : '1.2-2' }}
                    </ng-container>
                    <ng-container *ngIf="isEditableParcela[rowIndex]">
                      <mat-form-field class="full-width">
                        <input tabIndex="4" matInput id="valorTotal" type="text" name="valorTotal" step="any"
                          (focus)="$event.target.select()" [formGroupName]="rowIndex"
                          [formControl]="row.controls['valorTotal']" (blur)="saveParcela(rowIndex, row)" currencyMask
                          [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                      </mat-form-field>
                    </ng-container>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              
              <ngx-datatable-column name="Tipo Cobrança" [minWidth]="100" [maxWidth]="300">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditableParcela[rowIndex]">
                    {{ (row?.value.tipoCobranca?.codigo??'0').toString().padStart(3, '0') + '-' + row?.value.tipoCobranca?.descricao}}
                  </ng-container>
                  <ng-container *ngIf="isEditableParcela[rowIndex]">
                    <mat-form-field class="full-width">
                      <mat-label>Tipo Cobrança</mat-label>
                      <mat-select [formGroupName]="rowIndex" [formControl]="row?.controls['tipoCobranca']" (selectionChange)="onSelectionChangeTipoCobranca($event)">
                        <mat-option>
                          <ngx-mat-select-search [formGroupName]="rowIndex" [formControl]="row?.controls['searchTipoCobranca']!"
                            placeholderLabel="Pesquisar Tipo Cobrança" noEntriesFoundLabel="Tipo Cobrança não encontrada" [searching]="searching">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let tipoCobranca of filteredTipoCobrancas | async" [value]="tipoCobranca">
                          <span>{{ (tipoCobranca?.codigo??'0').toString()?.padStart(3, '0') + '-' + tipoCobranca?.descricao }}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Portador" [minWidth]="100" [maxWidth]="200">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditableParcela[rowIndex]">
                    {{ (row?.value.portadorId?.codigo??'0').toString().padStart(3, '0') + '-' + row?.value.portadorId?.descricao }}
                  </ng-container>
                  <ng-container *ngIf="isEditableParcela[rowIndex]">
                    <mat-form-field class="full-width">
                      <mat-label>Portador</mat-label>
                      <mat-select [formGroupName]="rowIndex" [formControl]="row.controls['portadorId']" (selectionChange)="onSelectionChangePortador($event)">
                        <mat-option>
                          <ngx-mat-select-search [formGroupName]="rowIndex" [formControl]="row.controls['searchPortador']"
                            placeholderLabel="Pesquisar Portador.." noEntriesFoundLabel="Portador não encontrada" [searching]="searching">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let portador of portadores" [value]="portador">
                          <span>{{ (portador?.codigo??'0').toString().padStart(3, '0') + '-' + portador?.descricao }}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Saldo" [minWidth]="100" [maxWidth]="120">
                <ng-template ngx-datatable-header-template let-column="column">
                  <div style="text-align:right">
                    <span title="Valor Nominal do Título">Saldo</span>
                  </div>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div style="text-align:right">
                    {{ row?.value?.valorSaldo | number : '1.2-2' }}
                  </div>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </form>
      </div>
    </div>
  </mat-card>
  <!-- <div class="paginator-wrapper">
    <mat-paginator
      #paginatorItem
      [length]="parcelasFormArray?.controls?.length || 0"
      [showFirstLastButtons]="true"
      [pageSize]="pageSizeItem"
      [pageSizeOptions]="pageSizeOptionsItem"
      (page)="pageEventItem = setPageSizeOptionsItem($event)"
    >
    </mat-paginator>
  </div> -->
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon> {{"CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>